export var CURRENCY_VALUE_PRECISION = 2;
export var DEFAULT_LOCALE = 'en-US';